import React from 'react';

type ButtonVariant = 'primary' | 'secondary' | 'ghost';

interface ButtonProps {
  children: React.ReactNode;
  variant?: ButtonVariant;
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
  type?: 'button' | 'submit';
  className?: string;
}

export default function Button({
  children,
  variant = 'primary',
  disabled = false,
  loading = false,
  onClick,
  type = 'button',
  className = '',
}: ButtonProps) {
  const getVariantClasses = (): string => {
    switch (variant) {
      case 'primary':
        return 'bg-neonOrange text-trueBlack';
      case 'secondary':
        return 'bg-gold text-trueBlack';
      case 'ghost':
        return 'bg-transparent border-2 border-offWhite text-offWhite';
      default:
        return 'bg-neonOrange text-trueBlack';
    }
  };

  const isDisabled = disabled || loading;

  return (
    <button
      type={type}
      disabled={isDisabled}
      onClick={onClick}
      className={`
        ${getVariantClasses()}
        shadow-brutalist
        transition-all duration-200
        hover:shadow-brutalist-sm
        hover:-translate-y-0.5
        active:translate-y-0.5
        focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black
        disabled:opacity-50 disabled:cursor-not-allowed
        ${className}
      `}
    >
      {loading ? (
        <span className="flex items-center gap-2">
          <span
            className="inline-block w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin"
            role="status"
            aria-label="Loading"
          />
          {children}
        </span>
      ) : (
        children
      )}
    </button>
  );
}
